// SKIN-695 — pure derivations for the open-visits card, kept out of the
// component so they can be unit-tested without a render harness.

const DAY_MS = 24 * 60 * 60 * 1000;

/** Whole days a visit has been open, floored. Null when the date is missing/invalid. */
export function daysOpen(createdAtIso: string, now: Date = new Date()): number | null {
    if (!createdAtIso) return null;
    const d = new Date(createdAtIso);
    if (isNaN(d.getTime())) return null;
    return Math.floor((now.getTime() - d.getTime()) / DAY_MS);
}

/** An empty shell has no live submission (null/undefined firstSubmissionId) → Void, not Close. */
export function isEmptyShell(firstSubmissionId?: number | null): boolean {
    return firstSubmissionId == null;
}

/** A locale date string, or '-' for a missing/unparseable ISO date. */
export function formatDate(iso: string): string {
    if (!iso) return '-';
    const d = new Date(iso);
    return isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
}
